/*
check to see compatibility for methods in browsers
https://developer.mozilla.org/en-US/docs/Web/API/FormData
 */
class Form {

	constructor(element){
		this.element = element;
		this.formData = new FormData(element);
		this.action = this.element.getAttribute('action');
	}

	static create(element,data=null){
		let form =  new Form(
			element
		);

		if( ! data ) return form;
		form.appendMany(data);

		return form;
	}

	/*
	https://developer.mozilla.org/en-US/docs/Web/API/FormData/append
	 */
	append(name, value, filename){
		if( filename ){
			return this.formData.append(name, value, filename);
		}
		return this.formData.append(name, value);
	}

	appendMany(data){
		for(let entry in data){
			this.append(entry,data[entry]);
		}
	}

	data(){
		return this.formData;
	}

	setAction(action){
		this.action = action;
	}

	isValid(){
		var $form = $(this.element);
		let validator = $(this.element).data('validator');
		if( validator &&  ! validator.valid() ){
			return false
		}
		return true;
	}
	
	reset(){
		var $form = $(this.element);
		let validator = $(this.element).data('validator');
		this.element.reset();
		if( validator ){
			validator.resetForm();
			$form.find('input,select,textarea').removeClass('valid error');
		}
	}

	post(data={}){

		return $.ajax($.extend({
			type:'POST',
			url: this.action,
			data: this.data(),
			cache: false,
			contentType: false,
			processData: false,
			dataType: 'json',
		},data));
	}
}

export default Form;
